export default __webpack_public_path__ + "static/media/Barbieri-MarcaGrafica-Footer.44016681.svg";